import { defineComponent, createElementBlock, openBlock, mergeProps, unref, renderSlot } from "vue";
import { useOverlayMask } from "../../../../composables/useOverlay.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DialogOverlayChildren",
  setup(__props) {
    const { attribute, needAnimateIn, needAnimateOut } = useOverlayMask();
    return (_ctx, _cache) => (openBlock(), createElementBlock("div", mergeProps({
      class: {
        "data-[state=open]:animate-in": unref(needAnimateIn),
        "data-[state=closed]:animate-out": unref(needAnimateOut)
      }
    }, { ...unref(attribute) }), [
      renderSlot(_ctx.$slots, "default")
    ], 16));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DialogOverlayChildren.js.map
